import React from "react";

import { SignatureSuccessDesktop as StyledSignatureSuccessDesktop } from "./SignatureSuccessDesktop.styles.js";
import { formatCpf, formatCnpj } from '../../../utils/formatter';


import Loading from "../../../components/Loading";
import certifiedOn from "../../../assets/images/Certified on.svg";

function SignatureSuccessDesktop({ document, exportPdf, loading }) {
	if (!document || loading) {
		return <Loading />;
	}

	return (
		<StyledSignatureSuccessDesktop className="doca">
			<StyledSignatureSuccessDesktop.Signature className="doca-flex doca-flex-col doca-flex-1 doca-w-full">
				<StyledSignatureSuccessDesktop.SignatureContainer className="doca-flex doca-flex-col doca-justify-start doca-items-center doca-items-center doca-w-full doca-p-8 doca-gap-3">
					<div className="doca-mb-6 doca-w-full">
						<StyledSignatureSuccessDesktop.HeaderTitle>
							Assinatura
						</StyledSignatureSuccessDesktop.HeaderTitle>
						<StyledSignatureSuccessDesktop.HeaderSubtitle>
							{document?.company?.name} enviou o seguinte documento para você assinar:
						</StyledSignatureSuccessDesktop.HeaderSubtitle>
					</div>
					<div className="doca-flex doca-justify-center doca-w-full">
						<StyledSignatureSuccessDesktop.ImageSuccess src={certifiedOn} />
					</div>
					<div className="doca-flex doca-justify-center doca-w-full">
						<StyledSignatureSuccessDesktop.SignatureTitle>
							O documento foi assinado com sucesso!
						</StyledSignatureSuccessDesktop.SignatureTitle>
					</div>
					<div className="doca-flex doca-justify-center doca-w-full">
						<StyledSignatureSuccessDesktop.SignatureText>
							Enviamos sua resposta para {document?.company?.name}.
						</StyledSignatureSuccessDesktop.SignatureText>
					</div>
					<div className="doca-w-full doca-px-2 doca-py-0">
						<StyledSignatureSuccessDesktop.ContainerSignature className="doca-flex doca-justify-center doca-items-center doca-w-full doca-p-2">
							<StyledSignatureSuccessDesktop.SignatureBox src={document.signature_url} />
						</StyledSignatureSuccessDesktop.ContainerSignature>
					</div>
					<StyledSignatureSuccessDesktop.UserContainer>
						<StyledSignatureSuccessDesktop.UserName>
							{document?.destinatary?.name}
						</StyledSignatureSuccessDesktop.UserName>
						<StyledSignatureSuccessDesktop.Cpf>
							{document?.destinatary?.cpf ? formatCpf(document?.destinatary?.cpf) : formatCnpj(document?.destinatary?.cnpj)}
						</StyledSignatureSuccessDesktop.Cpf>
					</StyledSignatureSuccessDesktop.UserContainer>
					<div className="doca-flex doca-justify-center doca-w-full">
						<button className="doca-button doca-button--secondary" disabled={loading} onClick={exportPdf}>
							<i className="doca-icon doca-icon--small doca-icon__download" />
							Baixar documento
						</button>
					</div>
				</StyledSignatureSuccessDesktop.SignatureContainer>
			</StyledSignatureSuccessDesktop.Signature>
		</StyledSignatureSuccessDesktop>
	);
}

export default SignatureSuccessDesktop;
